import { Link } from "@/components/common/Link";
export default function ContractsOwnershipAndDisputePrevention() {
  return <section data-section-id="261122" id="contracts-ownership-and-dispute-prevention" className="bg-background py-20 text-foreground md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-secondary">
            Business Planning &amp; Continuity
          </p>

          <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-primary md:text-5xl lg:text-[3.25rem]">
            Legal Structure Through the Business Lifecycle
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            Business ownership is not a one-time legal event. Clear agreements,
            governance documents, transaction terms, and succession planning
            help define rights and obligations as the business develops,
            changes, and moves through significant transactions.
          </p>
        </div>

        {}
        <div className="mx-auto mt-12 max-w-3xl border-t border-border pt-10 text-center md:mt-14">
          <p className="text-base leading-relaxed text-muted-foreground md:text-lg">Practical legal guidance for South Florida business owners, including business formation, operating agreements for LLCs, shareholders' agreements for LLCs, shareholders' agreements and bylaws for corporations. We are proud of our contract preparation and review. Mr. Levine's business experience includes representing clients in the formation and operation of their business, as well as the purchase and sale of dozens of businesses. Remember our slogan: “My initials are ‘MIL,’ and you need ‘MIL’ to make MILLIONS.”</p>
        </div>

        {}
        <div className="mx-auto mt-16 max-w-6xl border-t border-border md:mt-20">
          {}
          <div className="grid gap-4 border-b border-border py-10 md:grid-cols-[120px_1fr_1.35fr] md:items-start md:gap-10 md:py-12">
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-secondary">
                01
              </span>

              <div aria-hidden="true" className="mt-3 h-px w-10 bg-secondary" />
            </div>

            <div>
              <p className="font-mono text-[0.7rem] uppercase tracking-[0.22em] text-secondary">
                Formation
              </p>

              <h3 className="mt-3 font-serif text-3xl font-light leading-[1.1] tracking-tight text-primary">
                Establishing the Business
              </h3>
            </div>

            <div>
              <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                Entity selection, ownership structure, initial governance, and
                operating agreements form the legal foundation of the business.
              </p>
            </div>
          </div>

          {}
          <div className="grid gap-4 border-b border-border py-10 md:grid-cols-[120px_1fr_1.35fr] md:items-start md:gap-10 md:py-12">
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-secondary">
                02
              </span>

              <div aria-hidden="true" className="mt-3 h-px w-10 bg-secondary" />
            </div>

            <div>
              <p className="font-mono text-[0.7rem] uppercase tracking-[0.22em] text-secondary">
                Governance
              </p>

              <h3 className="mt-3 font-serif text-3xl font-light leading-[1.1] tracking-tight text-primary">
                Defining How the Business Operates
              </h3>
            </div>

            <div>
              <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                Clear governance documents address management authority, voting
                rights, capital obligations, shareholder or member
                relationships, and internal decision-making.
              </p>
            </div>
          </div>

          {}
          <div className="grid gap-4 border-b border-border py-10 md:grid-cols-[120px_1fr_1.35fr] md:items-start md:gap-10 md:py-12">
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-secondary">
                03
              </span>

              <div aria-hidden="true" className="mt-3 h-px w-10 bg-secondary" />
            </div>

            <div>
              <p className="font-mono text-[0.7rem] uppercase tracking-[0.22em] text-secondary">
                Transactions
              </p>

              <h3 className="mt-3 font-serif text-3xl font-light leading-[1.1] tracking-tight text-primary">
                Preparing for Significant Business Decisions
              </h3>
            </div>

            <div>
              <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                Contracts, acquisitions, sales, representations, disclosures,
                payment obligations, and transition terms should define the
                parties&apos; rights and responsibilities before a transaction
                moves forward.
              </p>
            </div>
          </div>

          {}
          <div className="grid gap-4 border-b border-border py-10 md:grid-cols-[120px_1fr_1.35fr] md:items-start md:gap-10 md:py-12">
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-secondary">
                04
              </span>

              <div aria-hidden="true" className="mt-3 h-px w-10 bg-secondary" />
            </div>

            <div>
              <p className="font-mono text-[0.7rem] uppercase tracking-[0.22em] text-secondary">
                Continuity
              </p>

              <h3 className="mt-3 font-serif text-3xl font-light leading-[1.1] tracking-tight text-primary">
                Planning for Ownership Change
              </h3>
            </div>

            <div>
              <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                Succession, ownership transfers, exit planning, and related
                agreements can help preserve continuity when ownership or
                business circumstances change.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mx-auto mt-16 max-w-3xl pt-4 text-center md:mt-20">
          <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-secondary">
            The Next Step
          </p>

          <h3 className="font-serif text-3xl font-light leading-[1.08] tracking-tight text-primary md:text-4xl">
            Discuss Your Business Matter
          </h3>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
            Whether you are forming a business, reviewing governance documents,
            preparing for a purchase or sale, or planning an ownership
            transition, the first step is to clarify the matter, the documents
            involved, and the decisions that require attention.
          </p>

          <div className="mt-8">
            <Link to="/ContactUsPage" className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground no-underline transition-opacity hover:opacity-90">
              Request a Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>;
}